/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";
import { formValue } from "../../../services/formServiceFunctions";
import useForm from "../../../hooks/useForm";
import { requiredFieldDefault, textFieldDefault } from "../../../services/validationRules";
import ValidatorTextField from "../../Validator/ValidatorTextField";
import ValidatorForm from "../../Validator/ValidatorForm";
import ValidatorSelect from "../../Validator/ValidatorSelect";
import MenuItem from "@mui/material/MenuItem";
import SubmitButton from "../../Button/SubmitButton";
import _ from "lodash";
import ValidatorNumberField from "../../Validator/ValidatorNumberField";
import { Box } from "@mui/material";
import { processCostSupportStyle } from "../processCostSupportStyle";
import { ProcessCostSupportFormProps } from "../../../types/ProcessCostSupport";

const LegalExpensesInsurance = ({ pcs, onSubmit, isLoading }: ProcessCostSupportFormProps) => {
  const initialValues = {
    isCostCovered: pcs.isCostCovered,
    costCoverageAmount: pcs.costCoverageAmount,
    hasPotentialCoverage: pcs.hasPotentialCoverage,
    potentialCoverer: pcs.potentialCoverer,
  };

  const { values, errors, handleChange, handleSubmit, handleBlur, registerValidators, touchedValues } = useForm({
    initialValues,
    onSubmit,
    identifier: pcs,
  });

  return (
    <>
      <Box sx={processCostSupportStyle.sectionHeadline}>Rechtsschutzversicherung</Box>
      <ValidatorForm onSubmit={handleSubmit}>
        <Grid container sx={processCostSupportStyle.grid}>
          <Grid sx={processCostSupportStyle.question} size={12}>
            Übernimmt bereits jetzt schon Ihre Rechtsschutzversicherung oder eine andere Stelle oder Person die Kosten
            für das Verfahren?
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4
            }}>
            <ValidatorSelect
              label={"Übernahme Kosten"}
              name={"isCostCovered"}
              value={formValue(values, "isCostCovered")}
              onChange={handleChange}
              onBlur={handleBlur}
              registerValidators={registerValidators}
              dependentValidationFields={["costCoverageAmount"]}
            >
              <MenuItem value={"no"}>Nein</MenuItem>
              <MenuItem value={"yes"}>Ja</MenuItem>
            </ValidatorSelect>
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4
            }}>
            <ValidatorNumberField
              fieldType={"money"}
              numberType={"float"}
              name="costCoverageAmount"
              label="Betrag"
              value={formValue(values, "costCoverageAmount")}
              onChange={handleChange}
              onBlur={handleBlur}
              registerValidators={registerValidators}
              isHighlighted={formValue(values, "isCostCovered") === "yes"}
              error={!!errors["costCoverageAmount"]}
              helperText={errors["costCoverageAmount"]}
              disabled={formValue(values, "isCostCovered") !== "yes"}
            />
          </Grid>
          <Grid sx={processCostSupportStyle.question} size={12}>
            Haben Sie eine Rechtsschutzversicherung oder sind Sie Mitglied in einem Verein oder einer Organisation, die
            die Kosten übernehmen könnte?
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4
            }}>
            <ValidatorSelect
              label={"Übernahme Kosten zukünftig"}
              name={"hasPotentialCoverage"}
              value={formValue(values, "hasPotentialCoverage")}
              onChange={handleChange}
              onBlur={handleBlur}
              disabled={formValue(values, "isCostCovered") !== "no"}
              registerValidators={registerValidators}
              dependentValidationFields={["potentialCoverer"]}
            >
              <MenuItem value={"no"}>Nein</MenuItem>
              <MenuItem value={"yes"}>Ja</MenuItem>
            </ValidatorSelect>
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4
            }}>
            <ValidatorTextField
              name="potentialCoverer"
              label="Name Versicherung/Verein"
              value={formValue(values, "potentialCoverer")}
              onChange={handleChange}
              onBlur={handleBlur}
              validators={
                formValue(values, "hasPotentialCoverage") === "yes"
                  ? [...requiredFieldDefault, ...textFieldDefault]
                  : []
              }
              registerValidators={registerValidators}
              error={!!errors["potentialCoverer"]}
              helperText={errors["potentialCoverer"]}
              disabled={
                formValue(values, "isCostCovered") !== "no" || formValue(values, "hasPotentialCoverage") !== "yes"
              }
            />
          </Grid>
          <Grid size={12}>
            <SubmitButton
              error={_.keys(errors).length > 0}
              isLoading={isLoading}
              disabled={_.keys(touchedValues).length === 0}
              variant={"contained"}
              type={"submit"}
            >
              Änderungen speichern
            </SubmitButton>
          </Grid>
        </Grid>
      </ValidatorForm>
    </>
  );
};

export default LegalExpensesInsurance;
